import React from "react";

export default function PrivacyPolicy() {
    const containerStyle = {
        fontFamily: '"Segoe UI", Arial, sans-serif',
        lineHeight: 1.6,
        color: "#222",
        backgroundColor: "#fafafa",
        margin: 0,
        padding: "2rem",
    };

    const titleStyle = { color: "#056b2f", fontSize: "1.8rem" };
    const subtitleStyle = {
        color: "#0a7a3f",
        fontSize: "1.2rem",
        marginTop: "1.5rem",
    };
    const strongStyle = { color: "#0b642e" };

    return (
        <div style={containerStyle}>
            <h1 style={titleStyle}>Politique de Confidentialité</h1>
            <p>
                ImpactCar, propriété de <strong style={strongStyle}>Kodesh Consulting Inc.</strong>, respecte la vie
                privée de ses utilisateurs et s'engage à protéger leurs données
                personnelles conformément à la{" "}
                <strong style={strongStyle}>
                    Loi sur la protection des renseignements personnels et les documents
                    électroniques (LPRPDE)
                </strong>{" "}
                du Canada.
            </p>

            <h2 style={subtitleStyle}>1. Données collectées</h2>
            <p>
                Nous recueillons uniquement les informations nécessaires à l’utilisation
                du service : votre nom, adresse courriel, numéro de téléphone et
                position géographique (lorsque vous utilisez les fonctions de
                géolocalisation).
            </p>

            <h2 style={subtitleStyle}>2. Méthode de collecte</h2>
            <p>
                Les données sont saisies manuellement par l’utilisateur lors de la
                création de son compte ou de l’utilisation de l’application.
            </p>

            <h2 style={subtitleStyle}>3. Utilisation des données</h2>
            <p>
                Ces informations servent exclusivement à faciliter la mise en relation
                entre les membres de la communauté ICC pour le covoiturage gratuit.
            </p>

            <h2 style={subtitleStyle}>4. Partage et conservation</h2>
            <p>
                Aucune donnée n’est vendue ou partagée à des tiers. Les informations
                sont conservées de manière sécurisée tant que le compte de l’utilisateur
                reste actif.
            </p>

            <h2 style={subtitleStyle}>5. Sécurité</h2>
            <p>
                Nous utilisons des technologies de sécurité raisonnables pour protéger
                vos données contre tout accès non autorisé.
            </p>

            <h2 style={subtitleStyle}>6. Vos droits</h2>
            <p>
                Vous pouvez demander la suppression ou la modification de vos données
                personnelles à tout moment à travers notre application.
            </p>

            <h2 style={subtitleStyle}>7. Consentement</h2>
            <p>
                En utilisant l’application ImpactCar, vous consentez à la collecte et à
                l’utilisation de vos données conformément à cette politique.
            </p>
        </div>
    );
}


